import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";

export const saveNewProperty = async (data) => {
  addDoc(collection(db, "propiedades"), {
    ...data,
  });
};
